/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import Modal from 'react-modal';

Modal.setAppElement('#root');

export default function TransferModal(props) {
  const style = {
    content: {
      inset: 0,
      background: 'unset'
    }
  }
  return (
    <>
      <Modal
        isOpen = { props.active }
        style = { style }>
        <div className="dg-spinner-global" data-dg="dg-spinner">
          <div className="dg-overlay"></div>
          <p>Einen Augenblick bitte!<a id="dg-keyboard"></a></p>
        </div>
      </Modal>
    </>
  )
}